import React from "react";
import { alpha, Theme, ChipProps } from "@mui/material";

export type CopyableVariant = "chip" | "text";

export interface CopyableState {
  isCopied: boolean;
  isHovered: boolean;
  setIsHovered: (_v: boolean) => void;
  handleCopy: (_e?: React.MouseEvent) => void;
}

export interface CopyableBaseProps {
  initialLabel: string;
  t: (_key: string) => string;
  theme: Theme;
  state: CopyableState;
}

export interface CopyableChipProps extends CopyableBaseProps {
  size?: ChipProps["size"];
}

export interface CopyableTextProps extends CopyableBaseProps {
  maxWidth?: number;
}
/* =========================
   LABEL TEXT
========================= */
export const getLabelText = (
  isCopied: boolean,
  isHovered: boolean,
  initialLabel: string,
  t: (_key: string) => string,
): string => {
  if (isCopied) return t("common.copied");
  if (isHovered) return t("buttons.copy");
  return initialLabel;
};

/* =========================
   BACKGROUND COLOR
========================= */
export const getBackgroundColor = (
  isCopied: boolean,
  isHovered: boolean,
  theme: Theme,
): string => {
  if (isCopied) return alpha(theme.palette.success.main, 0.15);
  if (isHovered) return alpha(theme.palette.primary.main, 0.18);
  return alpha(theme.palette.primary.main, 0.1);
};
